import { useEffect } from 'react';

/**
 * A hook that calls the provided callback when the Escape key is pressed
 * @param callback The function to call when Escape is pressed
 * @param enabled Optional flag to enable/disable the listener (defaults to true)
 */
const useEscapeKey = (callback: () => void, enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return;
    
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callback();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback, enabled]);
};

export default useEscapeKey;